import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Observable } from 'rxjs';
import { PolicyService } from '../services/policy.service';

export const LoadedPoliciesGuardService: CanActivateFn = (route, state) => {
  const policyService = inject(PolicyService);

  return new Observable<boolean>((observer) => {
    policyService.loadPolicies().subscribe(() => {
      observer.next(policyService.hasPolicies());
      observer.complete();
    });
  });
};
